/* WAUSM Shop — interactions
   - Mobile nav toggle
   - Cart drawer open/close
   - Live cart count from /cart.js
   - Quantity steppers
   - Product gallery thumbnail switching
   - Product variant selection (URL param + price update)
*/
(function () {
  'use strict';

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* Mobile menu ------------------------------------------------------- */
  const menuToggle = $('[data-menu-toggle]');
  const siteNav = $('[data-site-nav]');
  if (menuToggle && siteNav) {
    menuToggle.addEventListener('click', () => {
      const open = siteNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open);
    });
  }

  /* Cart drawer ------------------------------------------------------- */
  const cartDrawer = $('[data-cart-drawer]');
  const cartOverlay = $('[data-cart-overlay]');
  const openCart = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  };
  const closeCart = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  };
  $$('[data-cart-open]').forEach(el => el.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  }));
  $$('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeCart(); });

  /* Cart fetch -------------------------------------------------------- */
  const fmtMoney = (cents) => {
    const v = (cents / 100).toFixed(2);
    return '$' + v;
  };

  async function fetchCart() {
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      return await r.json();
    } catch (e) {
      return null;
    }
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.setAttribute('data-count', count);
    });
  }

  async function refreshCart() {
    const cart = await fetchCart();
    if (!cart) return;
    updateCount(cart.item_count);
    renderDrawer(cart);
  }

  function renderDrawer(cart) {
    const body = $('[data-cart-drawer-body]');
    const footer = $('[data-cart-drawer-footer]');
    if (!body) return;

    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty.</p></div>';
      if (footer) footer.style.display = 'none';
      return;
    }
    if (footer) footer.style.display = '';

    body.innerHTML = cart.items.map(item => `
      <div class="cart-item" data-line-key="${item.key}" style="padding:1rem 0;border-bottom:1px solid var(--color-border);">
        <div class="cart-item__img">${item.image ? `<img src="${item.image}" alt="">` : ''}</div>
        <div style="flex:1;">
          <p class="cart-item__title"><a href="${item.url}" style="color:inherit;">${item.product_title}</a></p>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-item__variant">${item.variant_title}</p>` : ''}
          <p style="margin:.5rem 0 .25rem;font-weight:600;color:var(--color-primary);">${fmtMoney(item.final_line_price)}</p>
          <div style="display:flex;align-items:center;gap:.75rem;">
            <div class="qty-selector" data-qty data-key="${item.key}">
              <button type="button" data-qty-down aria-label="Decrease">−</button>
              <input type="number" value="${item.quantity}" min="0" data-qty-input>
              <button type="button" data-qty-up aria-label="Increase">+</button>
            </div>
            <button class="cart-item__remove" data-remove="${item.key}">Remove</button>
          </div>
        </div>
      </div>
    `).join('');

    const totalsEl = $('[data-cart-totals]');
    if (totalsEl) totalsEl.textContent = fmtMoney(cart.total_price);

    body.querySelectorAll('[data-qty]').forEach(setupQty);
    body.querySelectorAll('[data-remove]').forEach(btn => {
      btn.addEventListener('click', () => changeLine(btn.dataset.remove, 0));
    });
  }

  async function changeLine(key, qty) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    if (r.ok) refreshCart();
  }

  function setupQty(el) {
    const input = $('[data-qty-input]', el);
    const down = $('[data-qty-down]', el);
    const up = $('[data-qty-up]', el);
    const key = el.dataset.key;
    if (down) down.addEventListener('click', () => {
      const v = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
      input.value = v;
      if (key) changeLine(key, v);
    });
    if (up) up.addEventListener('click', () => {
      const v = (parseInt(input.value, 10) || 0) + 1;
      input.value = v;
      if (key) changeLine(key, v);
    });
    if (key) {
      input.addEventListener('change', () => changeLine(key, parseInt(input.value, 10) || 0));
    }
  }

  $$('[data-qty]').forEach(setupQty);

  /* Add to cart (AJAX) ------------------------------------------------ */
  $$('[data-product-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
      try {
        const fd = new FormData(form);
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: fd
        });
        if (r.ok) {
          await refreshCart();
          openCart();
        } else {
          const err = await r.json();
          alert(err.description || 'Could not add to cart');
        }
      } catch (err) {
        console.error(err);
      } finally {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to cart'; }
      }
    });
  });

  /* Product gallery --------------------------------------------------- */
  const thumbs = $$('[data-thumb]');
  const mainImg = $('[data-main-image]');
  thumbs.forEach(t => {
    t.addEventListener('click', () => {
      thumbs.forEach(x => x.classList.remove('is-active'));
      t.classList.add('is-active');
      if (mainImg) mainImg.src = t.dataset.image || $('img', t).src;
    });
  });

  /* Variant selection ------------------------------------------------- */
  const productForm = $('[data-product-form]');
  if (productForm) {
    const variantData = window.__productVariants || [];
    const optionInputs = $$('[data-option-input]', productForm);
    const variantIdInput = $('[name="id"]', productForm);
    const priceEl = $('[data-product-price]');
    const addBtn = $('[data-add-button]');

    function getSelected() {
      const opts = {};
      optionInputs.forEach(i => {
        if (i.type === 'radio' && i.checked) opts[i.name] = i.value;
        else if (i.type === 'select-one') opts[i.name] = i.value;
      });
      return opts;
    }

    function matchVariant() {
      const opts = getSelected();
      return variantData.find(v =>
        Object.keys(opts).every((k, i) => v.options[i] === opts[k])
      );
    }

    function updateForVariant() {
      const v = matchVariant();
      if (!v) return;
      if (variantIdInput) variantIdInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price_html || fmtMoney(v.price);
      if (addBtn) {
        if (!v.available) {
          addBtn.disabled = true;
          addBtn.textContent = 'Sold out';
        } else {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to cart';
        }
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }

    optionInputs.forEach(i => i.addEventListener('change', updateForVariant));
  }

  /* Initial load ------------------------------------------------------ */
  refreshCart();
})();
